export default {
  CONFIGURATION_SUBACCOUNT_ADD: {// 完成
    key: 'configuration_subaccount_add',
    label: '个人中心-子账号设置-【新绑子账号】'
  },
  CONFIGURATION_SUBACCOUNT_EDIT: {// 编辑修改
    key: 'configuration_subaccount_edit',
    label: '个人中心-子账号设置-【编辑子账号】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_SUBMIT: {// 提交
    key: 'configuration_subaccount_add_submit',
    label: '个人中心-子账号设置-新绑子账号-提交'
  },
  CONFIGURATION_SUBACCOUNT_EDIT_SUBMIT: {// 提交
    key: 'configuration_subaccount_edit_submit',
    label: '个人中心-子账号设置-编辑子账号-提交'
  },
  CONFIGURATION_SUBACCOUNT_ADD_TIME: {// 新建所用时长
    key: 'configuration_subaccount_add_time',
    label: '个人中心-子账号设置-新绑子账号-新建提交所用时长'
  },
  CONFIGURATION_SUBACCOUNT_EDIT_TIME: {// 编辑所用时长
    key: 'configuration_subaccount_edit_time',
    label: '个人中心-子账号设置-新绑子账号-编辑提交所用时长'
  },
  CONFIGURATION_SUBACCOUNT_BATCHADD: {// 完成
    key: 'configuration_subaccount_batchadd',
    label: '个人中心-子账号设置-【批量新绑子账号】'
  },
  CONFIGURATION_SUBACCOUNT_BATCHADD_TIME: {// 批量新绑子账号完成时间
    key: 'configuration_subaccount_batchadd_time',
    label: '个人中心-子账号设置-【批量新绑子账号】-完成时间'
  },
  CONFIGURATION_SUBACCOUNT_BATCHADD_PERCENT: {// 批量新绑子账号完成率
    key: 'configuration_subaccount_batchadd_percent',
    label: '个人中心-子账号设置-【批量新绑子账号】-完成率'
  },
  CONFIGURATION_SUBACCOUNT_BATCHDEL: {// 完成
    key: 'configuration_subaccount_batchdel',
    label: '个人中心-子账号设置-【批量解绑】'
  },
  CONFIGURATION_SUBACCOUNT_BATCHDEL_CONFIRM: {// 完成
    key: 'configuration_subaccount_batchdel_confirm',
    label: '个人中心-子账号设置-【批量解绑】-确定'
  },
  CONFIGURATION_SUBACCOUNT_BATCHDEL_TIME: {// 完成
    key: 'configuration_subaccount_batchdel_time',
    label: '个人中心-子账号设置-【批量解绑】-解绑所用时长'
  },
  CONFIGURATION_SUBACCOUNT_BATCHEXPORT: {// 完成
    key: 'configuration_subaccount_batchexport',
    label: '个人中心-子账号设置-【批量导出】'
  },
  CONFIGURATION_SUBACCOUNT_SEE: {// 需要确认
    key: 'configuration_subaccount_see',
    label: '个人中心-子账号设置-【隐藏小眼睛】'
  },
  CONFIGURATION_SUBACCOUNT_ONEPAGE: { // 完成
    key: 'configuration_subaccount_onepage',
    label: '个人中心-子账号设置-【当页全选】'
  },
  CONFIGURATION_SUBACCOUNT_ALLPAGE: {// 完成
    key: 'configuration_subaccount_allpage',
    label: '个人中心-子账号设置-【全部全选】'
  },
  CONFIGURATION_SUBACCOUNT_NUMBERPAGE: {// 完成
    key: 'configuration_subaccount_numberpage',
    label: '个人中心-子账号设置-【10条/页】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_PIN: {// 完成
    key: 'configuration_subaccount_add_pin',
    label: '个人中心-子账号设置-新绑子账号-【怎么查询京东账号】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_ROLES: {// 完成
    key: 'configuration_subaccount_add_roles',
    label: '个人中心-子账号设置-新绑子账号-【从已有角色中选择】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_CUSTOMROLES: {// 完成
    key: 'configuration_subaccount_add_customroles',
    label: '个人中心-子账号设置-新绑子账号-【自定义功能权限】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_ONLY: {// 完成
    key: 'configuration_subaccount_add_only',
    label: '个人中心-子账号设置-新绑子账号-【仅查看本账号数据】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_ADMIN: {// 完成
    key: 'configuration_subaccount_add_admin',
    label: '个人中心-子账号设置-新绑子账号-【同主账号数据】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_OTHERS: {// 完成
    key: 'configuration_subaccount_add_others',
    label: '个人中心-子账号设置-新绑子账号-【添加其他子账号】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_ROLE: {// 完成
    key: 'configuration_subaccount_add_role',
    label: '个人中心-子账号设置-新绑子账号-【按角色筛选】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_OTHERSQUERY: {// 本期不埋
    key: 'configuration_subaccount_add_othersquery',
    label: '个人中心-子账号设置-新绑子账号-【添加其它子账号-查询】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_OTHERSNEW: {// 完成
    key: 'configuration_subaccount_add_othersnew',
    label: '个人中心-子账号设置-新绑子账号-【添加其它子账号-添加】'
  },
  CONFIGURATION_SUBACCOUNT_ADD_OTHERSDEL: {// 完成
    key: 'configuration_subaccount_add_othersdel',
    label: '个人中心-子账号设置-新绑子账号-【添加其它子账号-移除】'
  }

}
